import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode"
import "swiper/css/scrollbar"

import "./Style.css";
import PropTypes from 'prop-types';


// import Swiper core and required modules
import SwiperCore, {
    FreeMode, Scrollbar, Mousewheel
} from 'swiper';

// install Swiper modules
SwiperCore.use([FreeMode, Scrollbar, Mousewheel]);

const CategoriesSwiper = ({ categories, select, type = 'link' /* or button*/, bgcolor = '#B3D0CC', textcolor = '#2D5752' }) => {

    const handleSelect = (data) => {
        if (type === 'link') {
            select(data);
        }
    }

    return (
        <>
            <Swiper direction={'horizontal'} slidesPerView={'auto'} freeMode={true} scrollbar={false} mousewheel={true} className="mySwiper2" passiveListeners={true}>
                <SwiperSlide className="swiper-slide-badges swiper-slide-custom">

                    {
                        categories.map(
                            (elem, i) => {
                                return (
                                    <div className="rounded-full text-cat p-badge text-white mr-1 ml-1" key={i + 1}
                                        onClick={() => { handleSelect(elem) }}
                                        style={{ background: bgcolor, color: textcolor }}>{elem.nameEs}</div>
                                )
                            }
                        )
                    }
                </SwiperSlide>
            </Swiper>
        </>
    )
}

CategoriesSwiper.propTypes = {
    categories: PropTypes.array,
    select: PropTypes.func
}

export default CategoriesSwiper;